import { useState } from 'react';

import { Box, Grid, GridItem } from '@chakra-ui/react';
import { motion } from 'framer-motion';

import { StaticPageFilter } from '@r-client/republic-capital/ui/static-page-filter';

import { CompanyLogo } from '../company-logo/company-logo';
import { FocusArea, IPortfolioCompany, PORTFOLIO_FILTERS } from './companies';

export interface ICompaniesListProps {
  companies: IPortfolioCompany[];
}

export const CompaniesList = ({ companies }: ICompaniesListProps) => {
  const [filter, setFilter] = useState<FocusArea>('Featured');

  const filteredCompanies = companies.filter((company) => {
    const matchesFilter =
      (company.featured && filter === 'Featured') || filter === 'All';
    const hasLogo = company.logo !== null;
    return matchesFilter && hasLogo;
  });

  return (
    <Box maxW="container.lg">
      <StaticPageFilter
        options={PORTFOLIO_FILTERS}
        includeAll
        currentOption={filter}
        onOptionChange={(value) => setFilter(value)}
        mb={6}
      />
      <motion.div
        key={filter}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Grid
          templateColumns={{
            base: 'repeat(2, minmax(0, 256px))',
            md: 'repeat(2, minmax(0, 256px))',
            lg: 'repeat(3, minmax(0, 256px))',
            xl: 'repeat(4, 256px)',
          }}
          gridAutoRows="1fr"
          gap={8}
          justifyContent={{ base: 'center', lg: 'space-between' }}
        >
          {filteredCompanies.map((company) => (
            <GridItem
              key={company.name}
              as={motion.div}
              _hover={{ cursor: 'pointer' }}
            >
              <CompanyLogo company={company} />
            </GridItem>
          ))}
        </Grid>
      </motion.div>
    </Box>
  );
};
